<div class="main-box">
    <ng-container>
        <nav id="mbfs-un-auth-box-nav-content-nav">
            <div class="mbfs-un-auth-box-nav-content-nav-links-wrapper">
                <div class="mbfs-un-auth-box-nav-content-nav-links">
                    <div class="mbfs-un-auth-box-nav-content-nav-links-lists">
                        <ul class="mbfs-un-auth-box-nav-content-nav-links-list"
                            [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
                            <!--US Header-->
                            <div *ngIf="!isCanadaPortal">
                              <li><a href="{{this.baseRedirect}}/home/financeleasesolutions"> {{ 'Header.FinanceSolutions' | translate }}</a></li>
                              <li><a href="{{this.baseRedirect}}/home/insurance"> {{ 'Header.Insurance' | translate }}</a></li>
                              <li><a href="{{this.baseRedirect}}/home/connected-insurance"> {{ 'Header.ConnectedInsurance' | translate }}</a></li>
                              <li><a href="{{this.baseRedirect}}/home/dynamicfinancing" target="_blank"> {{ 'Header.DynamicProducts' | translate }}</a></li>
                              <!-- <li><a href="{{this.baseRedirect}}/home/connectedinsurancelead"> {{ 'Header.ConnectedInsuranceLead' | translate }}</a></li> -->
                              <li><a href="{{this.baseRedirect}}/home/electricFMV" > {{ 'Header.EVSolutions' | translate }}</a></li>
                              <li><a href="{{this.baseRedirect}}/home/brochures" > {{ 'Header.Brochures' | translate }}</a></li>
                              <li><a href="{{this.baseRedirect}}/home/contactus" > {{ 'Header.ContactUs' | translate }}</a></li>
                          </div>

                          <!--Canada Header-->
                          <div *ngIf="isCanadaPortal">
                            <!-- <li class="mbfs-un-auth-box-nav-content-nav-links-header">
                              <button type="link"
                                  tabindex="-1"><span>{{ 'NavHeader.Menu' | translate }}</span></button>
                            </li> -->
                            <li><a  href="{{this.baseRedirect}}home/financeleasesolutions"  > {{ 'Header.FinanceSolutions' | translate }}</a></li>
                            <li><a  href="{{this.baseRedirect}}home/insurance" target="_blank"> {{ 'Header.ProtectionProducts' | translate }}</a></li>
                            <li><a  href="{{this.baseRedirect}}home/electricFMV"> {{ 'Header.EVSolutions' | translate }}</a></li>
                            <li><a  href="{{this.baseRedirect}}home/brochures" > {{ 'Header.Brochures' | translate }}</a></li>
                            <!-- <li><a  href="{{this.baseRedirect}}home/programs" >{{ 'Header.SpecialPrograms' | translate }}</a></li> -->
                            <li><a  href="{{this.baseRedirect}}home/contactus"  > {{ 'Header.ContactUs' | translate }}</a></li>
                          </div>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    </ng-container>
</div>
